import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import ProgressionModal from "../../../theme/ProgressionBuilder/ProgressionModal";
import ProgressionWrapper from "../../../theme/ProgressionBuilder/ProgressionWrapper";
import { useAddInboundMutation } from "../../../../newapi/inbound/inboundsSlice";
import { updateData } from "../../../../newapi/global/progressionTabSlice";
import Details from "./views/Details";
import InboundLines from "./views/InboundLines";
import Shipments from "./views/Shipments";
import MailPreview from "./views/MailPreview";

const MpAddInbound = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    // Seed the shared progression state when opened with prefilled data (e.g. from Inkoopadvies,
    // which supplies a supplier and inbound lines built from the selected forecast rows).
    useEffect(() => {
        if (props.open && props.initialData) {
            dispatch(updateData(props.initialData));
        }
    }, [props.open]); // eslint-disable-line react-hooks/exhaustive-deps

    const onSave = (response, openAfterSave) => {
        // Separate from handleClose, which also fires when the modal is dismissed. Callers that seeded
        // the modal from a selection only want to drop that selection once the inbound really exists.
        if (props.onSaved) {
            props.onSaved();
        }
        props.handleClose();
        // The create response carries the new inbound's id.
        if (openAfterSave && response?.id) {
            props.onOpenCreatedInbound?.(response.id);
        }
    }

    // Save and open is only offered where the caller can open the created inbound.
    const allowSaveAndOpen = !!props.onOpenCreatedInbound;

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper onSave={onSave} query={useAddInboundMutation} isModal title={t("add_inbound")}>
                <Details/>
                <InboundLines/>
                <Shipments allowSaveAndOpen={allowSaveAndOpen}/>
                <MailPreview allowSaveAndOpen={allowSaveAndOpen}/>
            </ProgressionWrapper>
        </ProgressionModal>
    )
}

export default MpAddInbound;